<template>
  <div class="display-comfirmation">
    <hr v-if="index !== 0" />
    <div class="display-container">
      <div>{{ label }}</div>
      <component
        :is="componentName"
        :value="value"
        :unit="unit"
        class="value-container"
        :dataTest="dataTest"
      ></component>
    </div>
  </div>
</template>

<script>
import DisplayValue from "../../atoms/displayValue/DisplayValue";
import DisplayValueWithUnit from "../../atoms/displayValue/DisplayValueWithUnit";
import DisplayValueDiseaseHistory from "../../atoms/displayValue/DisplayValueDiseaseHistory";
export default {
  props: {
    index: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    unit: {
      type: String
    },
    gender: {
      type: Boolean
    },
    condition: {
      type: Boolean
    },
    diseaseHistory: {
      type: Boolean
    },
    urinaryTest: {
      type: Boolean
    },
    urinarySugar: {
      type: Boolean
    },
    smokingHabit: {
      type: Boolean
    },
    whetherAbnormalTest: {
      type: Boolean
    },
    dataTest: String
  },
  components: {
    DisplayValue,
    DisplayValueWithUnit,
    DisplayValueDiseaseHistory
  },
  computed: {
    componentName: function() {
      // 使用頻度の低いやつはダイレクトインポートする
      let name = null;
      if (typeof this.unit === "string") {
        return "display-value-with-unit";
      } else if (this.gender) {
        name = "DisplayValueGender";
      } else if (this.diseaseHistory) {
        return "display-value-disease-history";
      } else if (this.condition) {
        name = "DisplayValueCondition";
      } else if (this.urinaryTest) {
        name = "DisplayUrinaryTest";
      } else if (this.urinarySugar) {
        name = "DisplayUrinarySugar";
      } else if (this.smokingHabit) {
        name = "DisplaySmokingHabit";
      } else if (this.whetherAbnormalTest) {
        name = "DisplayValueWhetherAbnormal";
      } else {
        return "display-value";
      }
      return () => import(`../../atoms/displayValue/${name}`);
    }
  }
};
</script>

<style scoped>
.display-comfirmation {
  margin-top: 20px;
}

.display-container {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
}
</style>
